var _filter, _clipPath, _clipPath2, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeotiff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.332031 8.730469 C 8.683594 8.636719 9.035156 8.539062 9.390625 8.4375 C 10.144531 8.214844 10.902344 8.019531 11.667969 7.847656 L 11.667969 10.394531 C 10.796875 10.570312 9.9375 10.796875 9.089844 11.078125 C 8.835938 11.160156 8.585938 11.234375 8.332031 11.308594 Z M 5.351562 15.667969 C 6.070312 15.667969 6.789062 15.621094 7.5 15.519531 L 7.5 12.386719 C 6.816406 12.535156 6.117188 12.609375 5.414062 12.605469 C 5.042969 12.605469 4.628906 12.578125 4.195312 12.539062 L 3.675781 15.539062 C 4.230469 15.625 4.792969 15.667969 5.351562 15.667969 Z M 5.351562 15.667969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.316406 4.8125 C 11.441406 4.761719 11.554688 4.714844 11.667969 4.671875 L 11.667969 7 C 10.757812 7.1875 9.9375 7.414062 9.164062 7.636719 C 8.878906 7.714844 8.605469 7.792969 8.332031 7.871094 L 8.332031 5.601562 C 9.363281 5.496094 10.371094 5.230469 11.316406 4.8125 Z M 16.8125 14.367188 L 16.226562 10.882812 C 14.980469 10.847656 13.734375 10.917969 12.5 11.097656 L 12.5 14.503906 C 13.453125 14.367188 14.417969 14.300781 15.382812 14.304688 C 15.863281 14.304688 16.339844 14.324219 16.8125 14.367188 Z M 16.8125 14.367188 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.589844 1.832031 C 10.386719 1.832031 10.347656 3.167969 7.140625 3.167969 C 5.863281 3.160156 4.59375 2.957031 3.375 2.566406 L 0.832031 17.320312 C 2.261719 17.917969 3.804688 18.207031 5.351562 18.167969 C 9.722656 18.167969 11.011719 16.804688 15.382812 16.804688 C 16.929688 16.761719 18.472656 17.050781 19.902344 17.652344 L 17.359375 2.566406 C 16.160156 2.09375 14.882812 1.84375 13.59375 1.832031 Z M 15.382812 15.972656 C 13.621094 15.976562 11.871094 16.214844 10.171875 16.675781 C 8.601562 17.109375 6.980469 17.328125 5.351562 17.332031 C 4.136719 17.34375 2.929688 17.160156 1.769531 16.792969 L 4.039062 3.621094 C 5.054688 3.867188 6.097656 3.992188 7.140625 4 C 8.363281 4.023438 9.570312 3.773438 10.683594 3.269531 C 11.59375 2.847656 12.589844 2.640625 13.589844 2.667969 C 14.621094 2.679688 15.640625 2.851562 16.617188 3.179688 L 18.84375 16.40625 C 17.714844 16.113281 16.550781 15.96875 15.378906 15.972656 Z M 13.589844 3.5 C 12.699219 3.476562 11.808594 3.660156 11 4.042969 C 9.789062 4.585938 8.46875 4.859375 7.140625 4.832031 C 6.328125 4.828125 5.515625 4.753906 4.714844 4.609375 L 2.71875 16.195312 C 3.582031 16.402344 4.464844 16.503906 5.351562 16.5 C 6.917969 16.492188 8.472656 16.28125 9.976562 15.867188 C 11.738281 15.386719 13.554688 15.140625 15.382812 15.136719 C 16.199219 15.136719 17.015625 15.203125 17.820312 15.332031 L 15.878906 3.824219 C 15.136719 3.617188 14.367188 3.507812 13.59375 3.5 Z M 8.332031 8.730469 C 8.683594 8.636719 9.035156 8.539062 9.390625 8.4375 C 10.144531 8.214844 10.902344 8.019531 11.667969 7.847656 L 11.667969 10.394531 C 10.796875 10.570312 9.9375 10.796875 9.089844 11.078125 C 8.835938 11.160156 8.585938 11.234375 8.332031 11.308594 Z M 7.5 11.53125 C 6.460938 11.761719 5.394531 11.824219 4.335938 11.714844 L 4.777344 9.148438 C 4.96875 9.164062 5.167969 9.1875 5.355469 9.1875 C 6.078125 9.179688 6.796875 9.09375 7.5 8.933594 Z M 12.5 7.6875 C 13.539062 7.511719 14.59375 7.429688 15.648438 7.453125 L 16.085938 10.050781 C 14.886719 10.023438 13.6875 10.089844 12.5 10.253906 Z M 15.148438 4.503906 L 15.507812 6.621094 C 14.5 6.609375 13.492188 6.6875 12.5 6.847656 L 12.5 4.421875 C 12.859375 4.359375 13.226562 4.328125 13.589844 4.332031 C 14.117188 4.335938 14.636719 4.394531 15.148438 4.503906 Z M 11.316406 4.8125 C 11.441406 4.761719 11.554688 4.714844 11.667969 4.671875 L 11.667969 7 C 10.757812 7.1875 9.9375 7.414062 9.164062 7.636719 C 8.878906 7.714844 8.605469 7.792969 8.332031 7.871094 L 8.332031 5.601562 C 9.363281 5.496094 10.371094 5.230469 11.316406 4.8125 Z M 7.140625 5.667969 C 7.265625 5.667969 7.378906 5.660156 7.5 5.65625 L 7.5 8.082031 C 6.65625 8.292969 5.785156 8.378906 4.917969 8.339844 L 5.398438 5.554688 C 5.976562 5.628906 6.558594 5.664062 7.140625 5.667969 Z M 3.675781 15.539062 L 4.191406 12.539062 C 4.597656 12.578125 5.007812 12.601562 5.414062 12.605469 C 6.117188 12.609375 6.816406 12.535156 7.5 12.386719 L 7.5 15.519531 C 6.789062 15.621094 6.070312 15.667969 5.351562 15.667969 C 4.792969 15.667969 4.230469 15.625 3.675781 15.539062 Z M 9.78125 15.054688 C 9.300781 15.171875 8.828125 15.285156 8.332031 15.378906 L 8.332031 12.175781 C 8.667969 12.082031 9 11.980469 9.339844 11.871094 C 10.105469 11.621094 10.878906 11.410156 11.664062 11.242188 L 11.664062 14.640625 C 10.996094 14.765625 10.382812 14.910156 9.78125 15.054688 Z M 15.378906 14.304688 C 14.417969 14.300781 13.453125 14.367188 12.5 14.503906 L 12.5 11.097656 C 13.730469 10.917969 14.980469 10.847656 16.222656 10.882812 L 16.8125 14.367188 C 16.335938 14.324219 15.859375 14.304688 15.378906 14.304688 Z M 15.378906 14.304688 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotiff);
export default __webpack_public_path__ + "static/media/geotiff.84b97b437355c94f83bc0969b49b525b.svg";
export { ForwardRef as ReactComponent };